

//vérification de l'existence de la variable d'environnement REACT_APP_BACKEND_URL
//function Formulaire({children,title,handleMouse,handleMouseleave,handlekeyUpgain,onclick,count,setCount,nom,postnom,prenom,sexe,telephone,Image,setNom,setPostnom,setPrenom,setSexe,setImage,setTelephone,setNomcomplet}){
    function Formulaire({categorie,setCategorie,setclasse,classe,classes,title,confirmSave,cour,ponderation, setPonderation,isLoading}){
      return(
            <>
        <div className="col-md-6 mx-auto mt-3">
            <form className="" onSubmit={confirmSave}>
                <div className="row">
                <div className="card-header">
                            
                            <h3 className=" card-title fw-bold">
                                {title} {cour}
                            </h3>
                        
                    </div>
                </div>
             
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="form-outline">
                                    <label className="form-label" for="grid-state">
                                        CLASSE  <span class="obligatoire">*</span>
                                    </label>
                                    <select className="form-select form-select-lg" id="grid-state" name="niveau"  onChange={(e)=>setclasse(e.target.value)} value={classe}>
                                    <option value="" selected disabled className="fw-bold">Choix de la classe</option>
                                        {
                                            classes.map((clas)=>
                                            <option value={clas.id} key={clas.id} className="fw-bold">{clas.nom}</option>
                                        )
                                        }
                                    
                                    
                                    </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="form-outline">
                                <label htmlFor="categorie" className="form-label">
                                    PONDERATION
                                </label>
                                <input type="number" maxLength={3} value={ponderation} onChange={(e)=>setPonderation(e.target.value)} className="form-control"   />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="form-outline">
                                <label htmlFor="categorie" className="form-label">
                                    CATEGORIE
                                </label>
                                <select name="categorie" id="" className="form-select" value={categorie} onChange={(e)=>setCategorie(e.target.value)}>
                                    <option value="" selected disabled>Choix de la catégorie</option>
                                    <option value="cours_option">COURS D'OPTION</option>
                                    <option value="secondaire">COURS SECONDAIRE</option>
                                    <option value="complémentaire">COURS COMPLEMENTAIRE</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-2 mt-2">
                            <button type="button" name="enregistrer" onClick={confirmSave} className="btn btn-primary w-100">
                                        {
                                            isLoading ? (
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            ) : (
                                                "Enregistrer"
                                                )
                                        }
                            </button>
                        </div>
                    </div>
                </form>
                </div>

            </>
        )
    }
    export default Formulaire;